import React from "react";
import { LOCKED_TEXTAREA_STYLE } from "../utils/Constants";
import HtmlContent from "./HtmlContent";
import ReadOnlyField from "./ReadOnlyField";

const brandLabelStyle = { fontSize: "16px", color: "#000000", fontWeight: "500" };

const FieldRow = ({ field, brand, fieldState }) => {
    const columnClass = brand ? " column" : "";

    return (
        <>
            {brand && (
                <div className="left column">
                    <label>
                        <span style={brandLabelStyle}>Brand: </span>
                        <span> {brand.brand}</span>
                    </label>
                    <label className="mt-4">
                        <span style={brandLabelStyle}>Model: </span>
                        <span> {brand.model}</span>
                    </label>
                </div>
            )}
            <div className={`left${columnClass}`}>
                <label>{field.label ?? ""}</label>
                <HtmlContent className="mt-4 instruction-content" html={field.addtionalFieldIntruction} />
            </div>
            <div className={`right${columnClass}`}>
                <ReadOnlyField field={field} value={fieldState?.value} />
                <textarea disabled value={fieldState?.comment || ""} style={LOCKED_TEXTAREA_STYLE} />
            </div>
        </>
    );
};

export default React.memo(FieldRow);